import type { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import { isGuestVisibleCarousel } from '../config/guestMode';

type LayoutScreenData = {
    data?: {
        content?: {
            carousels_v1?: Carousel[];
            carousels?: Carousel[];
        };
    };
} | null;

export function getActiveCarouselsFromLayout(layoutData: LayoutScreenData | undefined, isGuest: boolean): Carousel[] {
    const content = layoutData?.data?.content;
    if (!content) {
        return [];
    }

    const useCarouselsV1 = Object.prototype.hasOwnProperty.call(content, 'carousels_v1');
    const list = useCarouselsV1 ? content.carousels_v1 : content.carousels;
    if (!list?.length) {
        return [];
    }

    return list.filter((item) => {
        if (!isGuest) {
            return Boolean(item?.active);
        }
        return isGuestVisibleCarousel(item);
    });
}
